import React from 'react';
import {FormattedMessage} from 'react-intl';
import {pathnames as P} from '../../../_common/constants/pathnames';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const InspectionDetailsLink = () => {

  return (
    <AsideMenuLink
      pathname={P.NEW_INSPECTION_DETAILS}
      isSubSection={true}
      icon={'Folder_navy.svg'}
      label={<FormattedMessage id="inspection-details-page-link" defaultMessage="Inspection details"/>}
    />
  );
};

export default InspectionDetailsLink;
